import {
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { TuiDayRange } from '@taiga-ui/cdk';
import { TuiAxes, TuiBarChart } from '@taiga-ui/addon-charts';
import { TuiHint } from '@taiga-ui/core';
import { TelesuiviGraphiqueHintFuitesComponent } from '../../telesuivi-graphique-hint/telesuivi-graphique-hint-fuites/telesuivi-graphique-hint-fuites.component';
import { Observance } from '../../../models/observance';

@Component({
  selector: 'app-telesuivi-graphique-fuites',
  standalone: true,
  imports: [
    TuiAxes,
    TuiBarChart,
    TuiHint,
    TelesuiviGraphiqueHintFuitesComponent,
  ],
  templateUrl: './telesuivi-graphique-fuites.component.html',
  styleUrl: './telesuivi-graphique-fuites.component.scss',
})
export class TelesuiviGraphiqueFuitesComponent implements OnChanges {
  @Input() observanceList?: Observance[];
  @Input() periode?: TuiDayRange;

  fuitesList: number[] = [];
  dateList: Date[] = [];

  ngOnChanges(): void {
    this.fuitesList = [];
    this.dateList = [];

    // preparation dateDebut & dateFin
    var dateDebut: Date | undefined;
    var dateFin: Date | undefined;
    if (this.periode) {
      dateDebut = new Date(
        this.periode.from.year,
        this.periode.from.month,
        this.periode.from.day
      );
      dateFin = new Date(
        this.periode.to.year,
        this.periode.to.month,
        this.periode.to.day
      );
    }

    if (this.observanceList && dateDebut && dateFin) {
      this.observanceList.forEach(
        (observance: Observance) => {
          if (
            observance.date &&
            observance.date >= dateDebut! &&
            observance.date <= dateFin!
          ) {
            this.fuitesList.push(observance.fuites || null!);
            this.dateList.push(observance.date || null!);
          }
        }
      );
    }
  }
}
